export default __webpack_public_path__ + "static/media/event3.34b2784c.webp";